import { useSelector } from "react-redux";
import ButtonIcon from "../buttonUI/ButtonIcon";
import { CirclePlus } from "lucide-react";

const MobileActionHeader = (props) => {
  const data = useSelector((state) => state.data.data);
  const countListItem = data ? data.length : 0;
  const { children, btnText, title, navigate } = props;

  return (
    <div
      className={`items-center w-full ${"justify-between"} 2xs:max-md:flex hidden py-2`}
    >
      {children}
      {title && (
        <h2 className="text-2xl text-dark-blue font-poppins font-bold 2xs:max-md:text-sm">
          {title} <span className="text-xs">{`(${countListItem})`}</span>
        </h2>
      )}
      {btnText && (
        <ButtonIcon
          btnText={btnText}
          Icon={CirclePlus}
          size={15}
          nav={navigate}
        />
      )}
    </div>
  );
};

export default MobileActionHeader;
